import { find } from "lodash";
import { DEFAULT_LOCALE } from "../../../common/constants";
import { Translation } from "../../profile/models/translation.model";
import { UserRole } from "../models/role.model";

export const getTranslationForLocale = ({
    translations,
    locale = DEFAULT_LOCALE,
}: {
    translations: Translation[];
    locale?: string;
}) => find(translations, ["languageCode", locale]);

export const getRoleMapped = (
    role: UserRole,
    translatedRoleName?: string
): UserRole => ({
    ...role,
    name: translatedRoleName ?? role.name,
});
